// extracted by mini-css-extract-plugin
export default {"wrapper":"Reviews_wrapper__bLSb7","reviewContainer":"Reviews_reviewContainer__hPGgV","reviewCard":"Reviews_reviewCard__3xwuL"};